import { Injectable } from '@angular/core';
import { CoolHttp } from '@angular-cool/http';
import {
  CampaignId,
  CampaignPlayerDTO,
  CampaignPlayerId,
  CampaignPlayerInviteToken,
} from '../../../../../common/dto/campaigns.dto';
import { ServerUrls } from '../../../../../common/dto/server-urls';
import { MINUTE_IN_MILLISECONDS } from '../../../../../common/utils/date.utils';
import { Observable, Subject } from 'rxjs';
import { CacheState, CacheStateUpdater } from '@coool/cachestate';
import { filter } from 'rxjs/operators';
import { filterDefined } from '../utils/observable.utils';

const campaignPlayersCacheUpdater = new Subject<string | void>();

@Injectable()
export class CampaignPlayersService {
  constructor(private _http: CoolHttp) {}

  @CacheState({
    maxAgeMS: 5 * MINUTE_IN_MILLISECONDS,
    cacheKey: {
      generator: args => `campaign-players_${args[0]}`,
    },
    updatedObservable: campaignPlayersCacheUpdater.pipe(filterDefined()),
  })
  public getCampaignPlayersCACHED(campaignId: CampaignId): Observable<CampaignPlayerDTO[]> {
    return this._http.getObservable(
      ServerUrls.Campaigns.children.Players.children.Get.getAbsoluteUrlWithParams({
        [ServerUrls.Campaigns.children.Players.params.campaignId]: campaignId,
      }),
    );
  }

  @CacheStateUpdater({
    cacheKeyGenerator: args => `campaign-players_${args[0]}`,
    updatedNotifier: campaignPlayersCacheUpdater,
  })
  public async removePlayerAsync(campaignId: CampaignId, playerId: CampaignPlayerId) {
    await this._http.deleteAsync(
      ServerUrls.Campaigns.children.Players.children.DeleteById.getAbsoluteUrlWithParams({
        [ServerUrls.Campaigns.children.Players.params.campaignId]: campaignId,
        [ServerUrls.Campaigns.children.Players.children.DeleteById.params.playerId]: playerId,
      }),
    );
  }

  public async createCampaignPlayerInviteTokenAsync(campaignId: CampaignId): Promise<CampaignPlayerInviteToken> {
    return (
      await this._http.postAsync(
        ServerUrls.Campaigns.children.Players.children.InviteToken.children.Create.getAbsoluteUrlWithParams({
          [ServerUrls.Campaigns.children.Players.params.campaignId]: campaignId,
        }),
      )
    ).token;
  }

  public async joinCampaignWithTokenAsync(campaignId: CampaignId, token: CampaignPlayerInviteToken) {
    await this._http.postAsync(
      ServerUrls.Campaigns.children.Players.children.InviteToken.children.Redeem.getAbsoluteUrlWithParams({
        [ServerUrls.Campaigns.children.Players.params.campaignId]: campaignId,
      }),
      {
        token: token,
      },
    );
  }
}
